import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { InboxRoutingGuard } from './core/routing-guards/inbox-routing-guard';
import { LoginRoutingGuard } from './core/routing-guards/login-routing-guard';
import { ResellersTabRoutingGuard } from './core/routing-guards/resellers-tab-routing-guard';
import { CanMatchCrm } from './core/routing-guards/can-match-crm';

const defaultRoutes: Routes = [
  // App Path all subroutes are defined in the marketplace app routing module
  {
    path: 'products',
    loadChildren: () => import('./features/app-navigation/app-navigation.module').then((m) => m.AppNavigationModule),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'resellers',
    loadChildren: () => import('./features/resellers/resellers.module').then((m) => m.ResellersModule),
    canLoad: [LoginRoutingGuard, ResellersTabRoutingGuard],
  },
  {
    path: 'accounts-products', // New path to be used when a user is redirected to the app details page from the accounts table, it is a duplicate of the 'products' path
    loadChildren: () => import('./features/app-navigation/app-navigation.module').then((m) => m.AppNavigationModule),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'orders-products', // New path to be used when a user is redirected to the app details page from the accounts table, it is a duplicate of the 'products' path
    loadChildren: () => import('./features/app-navigation/app-navigation.module').then((m) => m.AppNavigationModule),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'accounts',
    loadChildren: () => import('./features/accounts/accounts.module').then((m) => m.AccountsModule),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'changerequests',
    loadChildren: () =>
      import('./features/spend-change-requests/spend-change-requests-routing.module').then(
        (m) => m.SpendChangeRequestsRoutingModule,
      ),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'orders',
    loadChildren: () => import('./features/orders/orders.module').then((m) => m.OrdersModule),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'work-orders',
    loadChildren: () =>
      import('./features/fulfillment-orders/fulfillment-orders.module').then((m) => m.FulfillmentOrdersModule),
    canLoad: [LoginRoutingGuard],
  },
  {
    path: 'inbox',
    outlet: 'inbox',
    loadChildren: () => import('@galaxy/conversation/inbox').then((m) => m.INBOX_ROUTES),
  },
  {
    path: 'inbox/channel/:id',
    children: [],
    canActivate: [InboxRoutingGuard],
  },
  {
    path: 'crm',
    loadChildren: () => import('@galaxy/crm/dynamic').then((m) => m.CrmModule),
    canLoad: [LoginRoutingGuard],
    canMatch: [CanMatchCrm],
  },
  { path: '', redirectTo: 'products', pathMatch: 'full' },
  // Authentication paths for login / registration
  {
    path: '',
    loadChildren: () => import('./features/authentication/authentication.module').then((m) => m.AuthenticationModule),
    pathMatch: 'prefix',
  },
  { path: 'apps', redirectTo: 'products' },
  { path: 'app-info', redirectTo: 'product-info' },
  // This effects all of dev central any route that doesn't match an api route or a client route
  // will match
  { path: '**', redirectTo: 'products' },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(defaultRoutes, {})],
  exports: [RouterModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppRoutingModule {}
